import { SortType } from './types';
import getComparison from 'components/V5Gadget/Matrix/getComparison';

const deltaSort = (
  isIgnoreWinningOrLosing: boolean,
  a: SortType,
  b: SortType,
) => {
  const { delta: deltaA, isGood: isGoodA } = getComparison({
    value: a.value,
    previous: a.previous,
    formatting: a.formatting,
    type: a.type,
  });
  const { delta: deltaB, isGood: isGoodB } = getComparison({
    value: b.value,
    previous: b.previous,
    formatting: b.formatting,
    type: b.type,
  });
  if (isIgnoreWinningOrLosing) {
    const absA = Math.abs(deltaA);
    const absB = Math.abs(deltaB);
    return absA - absB;
  } else {
    const absA = Math.abs(deltaA) * (isGoodA ? 1 : -1);
    const absB = Math.abs(deltaB) * (isGoodB ? 1 : -1);
    return absA - absB;
  }
};

export default deltaSort;
